import { RoleEnum } from 'app/auth/authRoles';
import { UserDTO } from 'app/auth/store/type';
import { ObjectId } from 'app/common.types';
import { StoreItemDTO } from '../../stores/type';

export interface CreateMerchantForm extends Required<Pick<UserDTO, 'firstName' | 'lastName' | 'email'>> {
  password: string;
  stripePaymentLinkId?: string;
}
export interface MerchantAndStore {
  id: string;
  franchiseId: string;
  firstName: string;
  lastName: string;
  email: string;
  isSubscribedRetailer: boolean;
  hasFullAccess: boolean;
  /** @deprecated */
  hasAcceptedCGV: boolean;
  isAdmin: boolean;
  stores: StoreItemDTO[];
  nbClients: number;
  nbPassages: number;
  isLoading: boolean;
  disabledAt?: string;
  isPartner?: boolean;
  pointsEarned30d?: number;
  lastMarketingSmsAt?: string | null;
  lastMarketingPushAt?: string | null;
}

export enum MerchantAndStoreUrlEnum {
  search = 'search',
  page = 'page',
  rowsPerPage = 'rowsPerPage',
  status = 'status',
  partner = 'partner',
}

export enum MerchantAndStoreSortEnum {
  NB_CLIENTS = 'nbClients',
  DATE_CREATED = 'dateCreated',
}

export enum FranchiseStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}

export enum PartnerFilterEnum {
  ALL = 'all',
  PARTNER = 'partner',
  NON_PARTNER = 'nonPartner',
}

export interface UberallInDTO {
  id: ObjectId;
  email: string;
  token: string;
}

export interface OwnerDTO {
  id: ObjectId;
  firstName: string;
  lastName: string;
  email: string;
  role: RoleEnum;
  uberall: UberallInDTO | null;
}

export type FranchiseWideAccessDTO = {
  grantedAt: string;
  grantedBy: { id: ObjectId; firstName: string | null; lastName: string | null; email: string | null } | null;
};

export type StoreOwnerAccessDTO = {
  id: ObjectId;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  /** Original managed stores, which a revoke restores. */
  stores: (Pick<StoreItemDTO, 'id' | 'name'> & { logo: string | null })[];
  franchiseWideAccess: FranchiseWideAccessDTO | null;
};

export enum UberallRoleEnum {
  UBER_API_ADMIN = 'UBER_API_ADMIN',
  API_ADMIN = 'API_ADMIN',
  ADMIN = 'ADMIN',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  LOCATION_MANAGER = 'LOCATION_MANAGER',
  BUSINESS_MANAGER_INBOX = 'BUSINESS_MANAGER_INBOX',
}

export interface UberallUserDTO {
  email: string;
  password?: string;
  id: ObjectId;
  firstname: string;
  lastname: string;
  role: UberallRoleEnum;
  managedLocations?: number[];
}

export interface UberallUserListOutDTO {
  offset: number;
  max: number;
  count: number;
  users: UberallUserDTO[];
}

export interface UberallProvisioningLocationDTO {
  id: number;
  identifier: string | null;
  name: string | null;
  streetAndNumber: string | null;
  zip: string | null;
  city: string | null;
  status: string | null;
}

export interface UberallProvisioningLocationListDTO {
  offset: number;
  max: number;
  count: number;
  locations: UberallProvisioningLocationDTO[];
}

export interface StoreUberallLinkDTO {
  locationId: number | null;
  takeoverDate: string | null;
  reportRecipientEmail: string | null;
}
